import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircle } from '@fortawesome/pro-solid-svg-icons'
import { useTranslation } from 'react-i18next'
import { CourseStateType, CourseStateTypeInverse } from 'enum/course-state.enum'
import styles from './CourseState.module.scss'

interface CourseStateProps {
  state: CourseStateType
}

export const CourseState = ({ state }: CourseStateProps) => {
  const { t } = useTranslation()
  const stateOption = (state: CourseStateType) => {
    const translateState = CourseStateType[Number(state)]
    return t(`commons.course.state.${translateState}`)
  }
  return (
    <div className={`${styles.state} ${styles[CourseStateTypeInverse[state]]}`}>
      <FontAwesomeIcon icon={faCircle} />
      {stateOption(state)}
    </div>
  )
}

export default CourseState
